// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { ConfiguratorContext_ProgramDataFragmentDoc, CommonFragment_FloorPlanAssetFragmentDoc } from '../../../fragments/circularFragments.generated';
export type ConfiguratorContext_AduStepFragment = { __typename?: 'CheckoutConfig', id: string, buildableAduPlans: Array<{ __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, salesPriceInCents?: number | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, rendering?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }>, aduProductOffering?: { __typename?: 'ProductOffering', id: string, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }> } | null | undefined };

export type AduStep_PlanListingFragment = { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, salesPriceInCents?: number | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, rendering?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined };

export type AduStep_SelectedPlanFragment = { __typename?: 'ProductOffering', id: string, floorPlanAssets: Array<{ __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }> };

export const AduStep_PlanListingFragmentDoc = gql`
    fragment AduStep_PlanListing on ProductOffering {
  id
  name
  baseConfig {
    id
    salesPriceInCents
  }
  minProgramData {
    ...ConfiguratorContext_ProgramData
  }
  maxProgramData {
    ...ConfiguratorContext_ProgramData
  }
  rendering {
    id
    previewUrl(resizing: {width: 2500, region: FULL})
  }
}
    ${ConfiguratorContext_ProgramDataFragmentDoc}`;
export const AduStep_SelectedPlanFragmentDoc = gql`
    fragment AduStep_SelectedPlan on ProductOffering {
  id
  floorPlanAssets {
    ...CommonFragment_FloorPlanAsset
  }
}
    ${CommonFragment_FloorPlanAssetFragmentDoc}`;
export const ConfiguratorContext_AduStepFragmentDoc = gql`
    fragment ConfiguratorContext_AduStep on CheckoutConfig {
  id
  buildableAduPlans {
    ...AduStep_PlanListing
  }
  aduProductOffering {
    ...AduStep_SelectedPlan
  }
}
    ${AduStep_PlanListingFragmentDoc}
${AduStep_SelectedPlanFragmentDoc}`;